import React from "react";
import checkmark from "../../images/checkmark.webp";
import close from "../../images/close.webp";
import "../../css/font-awesome.min.css";
import convertToRupiah from "../../utils/convertToRupiah";

const ProductCard = (props) => {
  return (
    <div className="product-card">
      <div className="header">
        <span className="license">{props.title}</span>
        <h2>{convertToRupiah(props.promo)}</h2>
        <span className="normal-price">{convertToRupiah(props.price)}</span>
        <a
          href={`https://api.whatsapp.com/send?phone=${props.contact.telephone.username}`}
          className="btn"
          rel="noreferrer"
          target="_blank"
          aria-label={`Melakukan Pemesanan ${props.title}`}
        >
          Pesan Sekarang
        </a>
      </div>
      <ul className="features">
        {props.included.length > 0 &&
          props.included.map((feature, key) => (
            <li key={key}>
              <img
                src={checkmark}
                className="included"
                alt="checked icon"
                loading="lazy"
              />
              <span className="included-feature">{feature.name}</span>
            </li>
          ))}
        {props.excluded.length > 0 &&
          props.excluded.map((feature, key) => (
            <li key={key}>
              <img
                src={close}
                className="excluded"
                alt="checked icon"
                loading="lazy"
              />
              <span className="excluded-feature">{feature.name}</span>
            </li>
          ))}
      </ul>
    </div>
  );
};

export default ProductCard;
